'use strict';

module.exports = function () {};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/function/noop.js
// module id = 883
// module chunks = 4